import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import OwnedVehicleForm from "../ownedVehicleForm/ownedVehicleForm";

export default class AddOwnedVehicle extends React.Component {
    render() {
        return (
            <AddItem
                class="add-owned-vehicle"
                header={i18n.t("dictionaries.ownedVehicles.actions.addOwnedVehicle.header")}
                content={<OwnedVehicleForm isUpdate={false} />}
            />
        );
    }
}
